<template>
  <div>
    <ReportsView v-if="loggedIn" />
    <Login v-if="!loggedIn" />
  </div>
</template>

<script>
import ReportsView from "./components/ReportsView.vue";
import Login from "./components/Login.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";

export default {
  name: "app",
  components: {
    ReportsView,
    Login
  },
  methods: {
    ...mapActions({
      initSlugs: "initSlugs",
      activateBySlug: "activateBySlug",
      openBySlug: "openBySlug"
    })
  },
  computed: mapState({
    loggedIn: state => state.loggedIn
  }),

  mounted() {
    /*this.initSlugs();
    if (report) {
      this.activateBySlug(report);
      this.openBySlug(report);
    } else {
      if (this.items && this.items.length > 0) {
        let slug = this.items[0].slug;
        this.activateBySlug(slug);
        this.openBySlug(slug);
      }
    }*/
  }
};
</script>
